import { z } from 'zod';
import { RowVersionSchema } from '../common/row-version.js';
import { AssetOwnerKindSchema } from './requests.js';
export const AssetOwnerSchema = z
    .object({
    row_version: RowVersionSchema,
    id: z.string(),
    name: z.string(),
    code: z.string().nullable(),
    kind: AssetOwnerKindSchema,
    is_disabled: z.boolean(),
})
    .strict();
// Vocabulary-scale list (attached-to-this-project only) — pagination "none".
export const AssetOwnerListResponseSchema = z.object({ items: z.array(AssetOwnerSchema) }).strict();
// Cross-project pool search (CONVENTIONS §Globally-pooled): minimal fields +
// the in_project flag so the picker greys already-attached entries.
export const AssetOwnerSearchResultSchema = AssetOwnerSchema.extend({
    in_project: z.boolean(),
}).strict();
export const AssetOwnerSearchResponseSchema = z
    .object({ items: z.array(AssetOwnerSearchResultSchema), has_more: z.boolean() })
    .strict();
export const AssetOwnerIdResponseSchema = z.object({ id: z.string() }).strict();
